import "./hero-style.css";
import {useState} from "react";
import {ModalOrder} from "../modal/order/ModalOrder";
import axios from "axios";
import {toast} from "react-toastify";

export const Hero = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const successfully = () => {
        toast.success('Заявка успешно отправлена', {
            position:'bottom-right'
        })
    }

    const errorServer = (err: string) => {
        toast.warning(err, {
            position:'bottom-right'
        })
    }
    const onSubmit = async (data: {name: string; phone: any; title: string}) => {
        try {
            const response = await axios.post('https://wow-holiday-server-miha823.amvera.io/api/order-call', data);
            if (response.data.success){
                successfully();
            }
        } catch (e) {
            console.error(e);
            errorServer('Заявка не отправлена. Повторите позже.')
        }
    }

    return (
        <>
        <section className="Hero" aria-label="Главная секция — организация детских праздников" id={'hero'}>
            <div className="container hero-container">
                <div className="hero-content">
                    <h1 className="content-title">
                        Вау… Праздник!!! — магия детства в каждом мгновении
                    </h1>
                    <p className="content-description">
                        Организуем незабываемые праздники для детей: квесты, шоу‑программы, тематические вечеринки
                    </p>
                    <div className="hero-cta">
                        <button
                            onClick={openModal}
                            className="btn primary"
                            aria-label="Оставить заявку на организацию праздника">
                            Оставить заявку
                        </button>
                    </div>
                </div>
            </div>
        </section>
            <ModalOrder isOpen={isModalOpen} onClose={closeModal} onSubmit={onSubmit} title={''}/>
        </>
    );
};
